import React from 'react';
import {EntityBoardPage} from './EntityBoardPage';

export function SalesBoardPage() {
  return (
    <EntityBoardPage entity={'sales'}/>
  );
}
